import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


import { useParams, useNavigate, Link } from "react-router-dom";

const EditBatterycard = () => {
  useAuthRedirect();
  const { id } = useParams(); // Get vehicle type ID from URL
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fld_rate: "" });
  const [suppliers, setsuppliers] = useState([]);

    const canEdit = hasPermission("Battery Card", "edit");

  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_supplier")
      .then((response) => {
        setsuppliers(response.data.suppliers);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);
  const parseLife = (lifeString) => {
    if (!lifeString) return { years: 0, months: 0 };

    const parts = lifeString.split("&").map(part => part.trim());

    let years = 0, months = 0;

    parts.forEach(part => {
        if (part.includes("year")) {
            years = parseInt(part.match(/\d+/)?.[0] || "0", 10);
        }
        if (part.includes("month")) {
            months = parseInt(part.match(/\d+/)?.[0] || "0", 10);
        }
    });
    return {
      years ,
      months 
    };
  };


  useEffect(() => {
    const fetchVehicleType = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_battery_card_api/${id}`
        );

      
        const parsedLife = parseLife(response.data.life);

        setFormData({
          battery_make: response.data.battery_make,
          battery_type: response.data.battery_type,
          battery_code: response.data.battery_code,
          purchase_from: response.data.purchase_from,
          life_y: parsedLife.years,
          life_m: parsedLife.months,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (id) fetchVehicleType();
  }, [id]);

  // ✅ Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
        battery_make: formData.battery_make,
        battery_type: formData.battery_type,
        life_y: formData.life_y,
        life_m: formData.life_m,
        purchase_from: formData.purchase_from,
        battery_code: formData.battery_code,
      };
  

    try {

        Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
          
      await axios.put(
        `https://rfs2.infraconsoft.net.in/api/edit_battery_card_api/${id}`,
        payload
      );

    Swal.fire({
        title: "Success!",
        text: "Updated successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true,
    }).then(() => {
        navigate("/battery_card_listing");
    });
    } catch (error) {
      console.error("Error updating details:", error);
      alert("Failed to update record");
    }
  };

  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
                    <h2 className="add-txt">Edit Battery Card</h2>
                    <Link to='/battery_card_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
              <label>Battery Code:</label>
                <input
                  type="text"
                  name="battery_code"
                  value={formData.battery_code}
                  onChange={handleChange}
                  required
                /> 
              </div>
              <div className="form-group">
              <label>Battery Make:</label>
                <input
                  type="text"
                  name="battery_make"
                  value={formData.battery_make}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Battery Type:</label>
                <input
                  type="text"
                  name="battery_type"
                  value={formData.battery_type}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Purchased from:</label>
                <select  name="purchase_from" value={formData.purchase_from}   className="branch-select" onChange={handleChange} >
                    <option value="">Select Supplier</option>
                    {suppliers.map((item) => (
                        <option key={item.supplierMaster_code} value={item.supplierMaster_code}>
                        {item.supplierMaster_name}
                        </option>
          ))}
        </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Expected Life (years):</label>
                <select  name="life_y" value={formData.life_y}   className="branch-select"  onChange={handleChange}>
                <option value="">--- Select ---</option>
                <option value="0 year">0 year</option>
                <option value="1 year">1 year</option>
                <option value="2 years">2 years</option>
                <option value="3 years">3 years</option>
                <option value="4 years">4 years</option>
                <option value="5 years">5 years</option>
                <option value="6 years">6 years</option>
                <option value="7 years">7 years</option>
                <option value="8 years">8 years</option>
                <option value="9 years">9 years</option>
            </select>
              </div>
              <div className="form-group">
                <label>Expected Life (Months) :</label>
                <select  name="life_m" value={formData.life_m}   className="branch-select" onChange={handleChange} >
                    <option value="">--- Select ---</option>
                    <option value="0 month">0 month</option>
                    <option value="1 month">1 month</option>
                    <option value="2 months">2 months</option>
                    <option value="3 months">3 months</option>
                    <option value="4 months">4 months</option>
                    <option value="5 months">5 months</option>
                    <option value="6 months">6 months</option>
                    <option value="7 months">7 months</option>
                    <option value="8 months">8 months</option>
                    <option value="9 months">9 months</option>
                    <option value="10 months">10 months</option>
                    <option value="11 months">11 months</option>
                </select>
              </div>
            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditBatterycard;
